import { StringUtils, engineComponent } from "neo-common";
import { TimelineElement } from "../Components/Elements/Graphics/TimelineElement";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ImageTextCounterElement } from "../Components/Elements/Texts/ImageTextCounterElement";
import { SongAttributes } from "../Components/Sounds/Song";
import { PlayList } from "../Components/Sounds/PlayList";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";

/**
 * TimelineElement is element which can create animation flow from object and setting up these elemenets based on frames.
 * TimelineElement need TimelineStyle as definition of animation.
 * Example:
 *   <TimelineElement Class="TimelineElement" Style="TimelineStyle" Loop="true" />
 *
 * @class TimelineElement
 * @extends BaseElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class TimelineElementExtended extends TimelineElement {
    private _fromValue: number;

    play(winValue?: number, fromValue?: number): void {
        this._fromValue = 0;
        if (fromValue != null) {
            this._fromValue = fromValue;
        }

        super.play(winValue);
    }

    public skipToFrame(frame: number): void {
        if (this._framesArray.indexOf(frame) > -1) {
            this._frameCounter = this._framesArray.indexOf(frame);
            this.animate();
        }
    }

    protected goToFrame(frame: number) {
        if (this._style != null && this._style.frames != null) {
            let node: Element = this._style.frames[frame.toString()];

            if (node.hasAttribute("Emit")) {
                this.emit(node.getAttribute("Emit"));
            }

            if (node != null && node.childElementCount > 0) {
                let next: Element = node.firstElementChild;
                if (next != null) {
                    while (next != null) {
                        let element: any = this._elements.childs[next.nodeName];
                        if (element != null) {
                            // send new node to element and set / change new attributes
                            element.updateByNode(next);
                            if (element instanceof ImageTextCounterElement && this._winValue != null) {
                                if (element.visible) {
                                    element.start(this._fromValue, this._winValue);
                                    this._winValue = null;
                                }
                            }
                        }
                        next = next.nextElementSibling;
                    }
                }
            }

            if (this._style != null && this._style.framesSounds != null) {
                let node2: Element = this._style.framesSounds[frame.toString()];
                if (node2 != null) {
                    let next: Element = node2.firstElementChild;
                    if (next != null) {
                        while (next != null) {
                            if (next.hasAttribute(SongAttributes.SONG)) {
                                if (next.hasAttribute(SongAttributes.PLAY)) {
                                    if (next.hasAttribute(SongAttributes.FADEIN)) {
                                        PlayList.play(
                                            next.getAttribute(SongAttributes.SONG),
                                            parseInt(next.getAttribute(SongAttributes.FADEIN)),
                                        );
                                    } else {
                                        PlayList.play(next.getAttribute(SongAttributes.SONG));
                                    }
                                }
                                if (next.hasAttribute(SongAttributes.LOOP)) {
                                    if (next.hasAttribute(SongAttributes.FADEIN)) {
                                        PlayList.loop(
                                            next.getAttribute(SongAttributes.SONG),
                                            parseInt(next.getAttribute(SongAttributes.FADEIN)),
                                        );
                                    } else {
                                        PlayList.loop(next.getAttribute(SongAttributes.SONG));
                                    }
                                }
                                if (next.hasAttribute(SongAttributes.STOP)) {
                                    if (next.hasAttribute(SongAttributes.FADEOUT)) {
                                        PlayList.stop(
                                            next.getAttribute(SongAttributes.SONG),
                                            parseInt(next.getAttribute(SongAttributes.FADEOUT)),
                                        );
                                    } else {
                                        PlayList.stop(next.getAttribute(SongAttributes.SONG));
                                    }
                                }
                            }
                            next = next.nextElementSibling;
                        }
                    }
                }
            }
        }
    }

    getElementsContainer(): ContainerElement {
        return this._elements;
    }

    clone(): TimelineElementExtended {
        let element: TimelineElementExtended = new TimelineElementExtended();

        element._elements = this._elements.clone();
        element.addChild(element._elements);
        element._style = this._style;
        element._framesArray = this._framesArray;
        element._loop = this._loop;
        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.visible = this.visible;

        if (this.maskSprite != null) {
            let elementMask = new PIXI.Sprite((<PIXI.Sprite>this.maskSprite).texture);
            elementMask.position.x = this.maskSprite.position.x;
            elementMask.position.y = this.maskSprite.position.y;

            element.maskSprite = elementMask;
            element.addChild(elementMask);
            element.mask = elementMask;
        }

        element.markAsCloned(); // must be called last before return!
        return element;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/TimelineElementExtended.ts
 **/